import { render, staticRenderFns } from "./simPkgUse.vue?vue&type=template&id=31ce86ae&scoped=true&"
import script from "./simPkgUse.vue?vue&type=script&lang=js&"
export * from "./simPkgUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce86ae",
  null
  
)

export default component.exports